import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { translateCol } from '../../custom/columnI18n';
import useVisinaTabele from "../../custom/visinaTabele";

const Dozvole = () => {
  const { t } = useTranslation();

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [selectedRowIdCemt , setSelectedRowIdCemt] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const [statusiDB, setStatusiDB] = useState([]);
  /* Brojac osvezavanja: posle snimanja statusa spisak se mora ponovo povuci,
     inace bi tabela pokazivala staru vrednost dok se strana ne otvori opet. */
  const [osveziKljuc, setOsveziKljuc] = useState(0);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  // useEffect(() => {

  //   let requestOptions = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + auth.token,
  //     },
  //     body: JSON.stringify({
  //       firma_id: company.companyId
  //     }),
  //   };
 
  //   fetch(process.env.REACT_APP_BACKEND_URL + `/permits`, requestOptions)
  //     .then(handleErrors)
  //     .then((data) => {

        
  //       setTableData(data)
  //         // Extract all available columns from the first data row
  //      const firstRow = data?.[0] ?? {};
  //       const columns = Object.keys(firstRow)
  //       .filter(k => !['ID'].includes(k))
  //       .map(k => ({ label: k, value: k }));

  //       setAllColumns(columns);
  //       setSelectedColumns(columns.slice(0, 15).map(c => c.value));

  //       // -- ili, robusnije: unija ključeva kroz sve redove --
  //       const allKeys = Array.from(new Set(data.flatMap(obj => Object.keys(obj || {}))));
  //       const columnsUnion = allKeys
  //       .filter(k => !['ID'].includes(k))
  //       .map(k => ({ label: k, value: k }));

  //       setAllColumns(columnsUnion);
  //       setSelectedColumns(columnsUnion.slice(0, 15).map(c => c.value));
  //     })
  //     .catch((error) => {
  //       error.json().then((errorMessage) => {
  //         toast.current.show({
  //           severity: "error",
  //           summary: "Error",
  //           detail: errorMessage.message,
  //           life: 3000,
  //         });
  //         console.log(errorMessage);
  //       });
  //     });
  // }, []);

  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL + "/permits/statusi", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
    })
      .then(handleErrors)
      .then((d) => setStatusiDB(Array.isArray(d) ? d : []))
      .catch(() => setStatusiDB([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Dozvola koju operater menja. Izbor ide iskljucivo kroz dugme "Izaberi",
     bez `onRowClick` — zajedno bi okidali dvaput i poništavali izbor. */
  const izaberiRed = (rowData) => {
    const id = rowData?.ID;
    setSelectedRowIdCemt(prev => (String(prev) === String(id) ? null : id));
  };

  const postaviStatus = (statusId) => {
    if (!selectedRowIdCemt) return;
    fetch(process.env.REACT_APP_BACKEND_URL + "/permits/status", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
      body: JSON.stringify({ id: selectedRowIdCemt, StatusFirma: statusId }),
    })
      .then(handleErrors)
      .then((d) => {
        toast.current.show({
          severity: d?.message && d.message.indexOf('Nema izmena') === 0 ? 'info' : 'success',
          summary: d?.message || t('common.save'),
          life: 3000,
        });
        setSelectedRowIdCemt(null);
        setOsveziKljuc(k => k + 1);
      })
      .catch((error) => {
        if (error?.json) error.json().then(e => toast.current.show({
          severity: 'error', summary: 'Error', detail: e.message, life: 3000,
        }));
      });
  };

  useEffect(()=>{
    let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              }
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/permits/MGSI", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                    if(data && data.message){
                                        toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                    }  
                                setTableData(data)
                                    // Extract all available columns from the first data row
                                const firstRow = data?.[0] ?? {};
                                  const columns = Object.keys(firstRow)
                                  .filter(k => !['ID'].includes(k))
                                  .map(k => ({ label: k, value: k }));

                                  setAllColumns(columns);
                                  setSelectedColumns(columns.slice(0, 15).map(c => c.value));

                                  // -- ili, robusnije: unija ključeva kroz sve redove --
                                  const allKeys = Array.from(new Set(data.flatMap(obj => Object.keys(obj || {}))));
                                  const columnsUnion = allKeys
                                  .filter(k => !['ID'].includes(k))
                                  .map(k => ({ label: k, value: k }));

                                  setAllColumns(columnsUnion);
                                  setSelectedColumns(columnsUnion.slice(0, 15).map(c => c.value));
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
           
      },[osveziKljuc])

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Dozvole');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      /* Prevodi se SAMO prikaz. `headers` ostaju sirovi aliasi, jer se po njima
         cita `row[headers[i]]` — prevedeno ime ne postoji kao kljuc u podacima. */
      const headerRow = worksheet.addRow(headers.map(h => translateCol(t, h)));
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Dozvole - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };

  const header = (
      <div className="export-buttons fakture-stavke-header">
          <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {/* Dugmad se pojavljuju tek kad je dozvola izabrana — inace nije
                  jasno nad cim bi klik delovao. "Poništi" postoji jer je status
                  rucni podatak, pa i pogresan klik mora da se ispravi. */}
              {selectedRowIdCemt && statusiDB.map(s => (
                  <Button key={s.value} type="button" label={s.label} severity="info"
                          onClick={() => postaviStatus(s.value)} />
              ))}
              {selectedRowIdCemt && (
                  <Button type="button" label={t('common.delete')} severity="danger" outlined
                          onClick={() => postaviStatus(null)} />
              )}
          </div>
          <input
              type="search"
              onInput={(e) => setGlobalFilter(e.target.value)}
              placeholder={t('nova.phPretraga')}
              className="p-inputtext p-component"
              style={{ width: '30%' }}
          />
      </div>
  );




  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData || []}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={r => String(r?.ID) === String(selectedRowIdCemt) ? { 'selected-row': true } : {}}
      >

         <Column header={t('common.choose')} style={{ minWidth: '110px' }}
                 body={(rowData) => (
                   <Button label={t('common.choose')} icon="pi pi-eye" type="button"
                           className="p-button-text p-button-sm"
                           onClick={() => izaberiRed(rowData)} />
                 )} />

         {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={translateCol(t, colMeta?.label || colKey)}
                    sortable
                    body={(rowData) => {
                      return rowData[colKey] || '-';
                    }}
                    style={{ minWidth: '150px'}}
                  />
                );
              })}
      </DataTable>
      </div>
    </div>
  );
};

export default Dozvole;